import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePostAuthorization } from "@sprout/client-components/dist/Post";
import RenderIfChildExists from "@sprout/client-components/dist/RenderIfChildExists";
import { MenuItemShare, useMenuItemPageCopy } from "@sprout/client-components/dist/MenuItemReusable";
import { MenuGrid, MenuTitle, MenuItem } from "@sprout/list-navigation/dist/Menu";
import { ItemType } from "sprout-graphql";
import { ArchiveOutlined, DeleteOutlined, PriorityHighOutlined, RestoreFromTrashOutlined, UnarchiveOutlined } from "sprout-ui-icons";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { useCallback } from "react";
import { useCurrentUser } from "@sprout/client-graphql";
import { PostPageToolbarMenuPopover, PostPageToolbarMenuCreatedAt, PostPageToolbarMenuViewMode } from "../PostPageToolbar";
import useConvertItemToPost from "../graphql/mutations/useConvertItemToPost";
const PostPageViewsTodoToolbarMenu = (props)=>{
    const { todo  } = props;
    const { id , isExplicitlyArchived , isExplicitlyDeleted , owner , createdAt , rootTopicOrSelf ,  } = todo;
    const authorization = usePostAuthorization(todo);
    const convertItemToPost = useConvertItemToPost();
    useActionRegistryGlobalHandler("CONVERT_TODO_TO_POST", useCallback(()=>{
        convertItemToPost({
            itemId: id,
            newParentId: rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.id,
            newType: ItemType.Post
        });
        return true;
    }, [
        convertItemToPost,
        id,
        rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.id
    ]), {
        skip: !authorization.convertToPost
    });
    const [, MenuItemCopy] = useMenuItemPageCopy();
    const currentUser = useCurrentUser();
    return /*#__PURE__*/ _jsxs(PostPageToolbarMenuPopover, {
        children: [
            /*#__PURE__*/ _jsx(MenuTitle, {
                children: "Leaf options"
            }),
            /*#__PURE__*/ _jsxs(RenderIfChildExists, {
                component: /*#__PURE__*/ _jsx(MenuGrid, {}),
                children: [
                    authorization.convertToPost && /*#__PURE__*/ _jsx(MenuItem, {
                        variant: "tile",
                        action: "CONVERT_TODO_TO_POST"
                    }),
                    authorization.addLabel && /*#__PURE__*/ _jsx(MenuItem, {
                        variant: "tile",
                        action: "PAGE_LABEL"
                    }),
                    authorization.assign && /*#__PURE__*/ _jsx(MenuItem, {
                        variant: "tile",
                        action: "PAGE_ASSIGN"
                    }),
                    authorization.archive && /*#__PURE__*/ _jsx(MenuItem, {
                        variant: "tile",
                        action: "PAGE_TOGGLE_ARCHIVE",
                        icon: isExplicitlyArchived ? UnarchiveOutlined : ArchiveOutlined,
                        label: isExplicitlyArchived ? "Unarchive" : "Archive"
                    })
                ]
            }),
            authorization.schedule && /*#__PURE__*/ _jsx(MenuItem, {
                action: "PAGE_DEADLINE"
            }),
            currentUser && /*#__PURE__*/ _jsx(MenuItem, {
                label: "Priority",
                icon: PriorityHighOutlined,
                action: "PAGE_TOGGLE_PRIORITY"
            }),
            /*#__PURE__*/ _jsx(PostPageToolbarMenuViewMode, {}),
            /*#__PURE__*/ _jsx(MenuItemCopy, {
                type: "leaf"
            }),
            /*#__PURE__*/ _jsx(MenuItemShare, {
                type: "leaf"
            }),
            authorization.trash && /*#__PURE__*/ _jsx(MenuItem, {
                action: "PAGE_TOGGLE_DELETE",
                label: isExplicitlyDeleted ? "Restore" : "Trash",
                icon: isExplicitlyDeleted ? RestoreFromTrashOutlined : DeleteOutlined
            }),
            authorization.delete && /*#__PURE__*/ _jsx(MenuItem, {
                action: "PAGE_PERMANENT_DELETE"
            }),
            owner && /*#__PURE__*/ _jsx(PostPageToolbarMenuCreatedAt, {
                createdAt: createdAt,
                owner: owner
            })
        ]
    });
};
export default PostPageViewsTodoToolbarMenu;
